module.exports = __webpack_public_path__ + "img/products.a41095f6.svg";